import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { isReadOnly } from 'utils/isReadOnly';
import { updateDealLineFiles } from 'utils/updateDealLineFiles';
import { getIsReseller, getMarketId } from 'store/publisher/selectors';
import { getIsEditingDisabled } from 'store/dealManagement/selectors/getIsEditingDisabled';
import { addToastNotification } from 'store/notification/reducer';
import FileUpload from 'lib/FileUpload';
import { processFrameFileContents } from './processFileContents';
import { FrameFileUploadButtonProps } from './FrameFileUploadButton.types';

const FrameFileUploadButton = ({
  listFiles,
  uploadedListOfFiles,
  setUploadedListOfFiles,
  theme,
  isDisabled = false,
  maxFileUploads,
  maxFileRows,
  requiredHeaders,
}: FrameFileUploadButtonProps): React.ReactElement => {
  const dispatch = useDispatch();
  const isEditingDisabled = useSelector(getIsEditingDisabled);
  const bookingStatusCode = useSelector((state: Store) => state.dealManagement.commonDeal.bookingStatusCode);
  const terminated = useSelector((state: Store) => state.dealManagement.commonDeal.currentLine.terminated);
  const marketId = useSelector(getMarketId);
  const readOnly = isReadOnly(bookingStatusCode, isEditingDisabled, terminated);
  const isReseller = useSelector(getIsReseller);

  return (
    <FileUpload
      uploadedFiles={uploadedListOfFiles}
      setUploadedFiles={setUploadedListOfFiles}
      existingFiles={listFiles}
      processFile={(file: File) => processFrameFileContents(file, marketId, isReseller, requiredHeaders)}
      mapToFileContents={updateDealLineFiles}
      maxFileUploads={maxFileUploads}
      maxFileRows={maxFileRows}
      isDisabled={readOnly || isDisabled}
      isFileUploadButton
      theme={theme}
      onNotification={(notification) => dispatch(addToastNotification(notification))}
    />
  );
};

export default FrameFileUploadButton;
